import { jsxs as L, jsx as v } from "react/jsx-runtime";
import { useRef as l, useState as w, useEffect as R } from "react";
import ve from "video.js";
/* empty css                                                                                  */
import { clsx as b } from "../../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { RocheUIImageRatio as Re, RocheUIImageFit as F } from "../../image/roche-image.types.js";
import { getCssAspectRatio as ge } from "../../image/roche-image-helpers.js";
import c from "../roche-video-player.module.scss.js";
import { RocheUIVideoPlayerControls as he } from "../roche-video-player-controls.js";
import { RocheUIVideoPlayerPreviewImage as ee } from "../roche-video-player-preview-image.js";
import u from "./roche-video-player.aws.module.scss.js";
import { getVideoPercentage as _e } from "./video-js-util.js";
const $e = ({
  awsServiceBaseUrl: te,
  options: g,
  fullscreen: h,
  videoLoop: o,
  preview: _,
  previewAlt: D,
  pauseLabel: re,
  playLabel: se,
  caption: A,
  videoId: V,
  onVideoStateChange: I,
  videoFit: ae,
  videoRatio: T,
  fillParentHeight: oe
}) => {
  var z, B;
  const W = l(null), a = l(null), i = l(I), J = l(V), H = l(A), n = h && !o, M = h && o, P = !!oe, ne = !!T && T !== Re.ORIGINAL, x = !n && (P || ne), G = ae ?? F.COVER, ce = x && G === F.COVER, le = x && G === F.CONTAIN, [E, k] = w(!1), [d, S] = w(!1), [ie, j] = w(!1), [s, C] = w(null), ue = d && ie, N = l(!1), U = l(!1), p = (B = (z = g.sources) == null ? void 0 : z[0]) == null ? void 0 : B.src, $ = g.autoplay;
  R(() => {
    i.current = I, J.current = V, H.current = A;
  }, [A, I, V]);
  const y = (t) => ({
    videoId: J.current,
    videoTitle: H.current ?? "",
    videoType: "aws",
    videoDurationTotal: t.duration() ?? 0,
    videoPercentageViewed: _e(t) ?? 0,
    videoUrl: p ?? "unknown videoUrl"
  }), f = `${te}${V}`;
  R(() => {
    let t = !0;
    return C(null), k(!1), S(!1), j(!1), fetch(`${f}/meta.json`).then((r) => {
      if (!r.ok)
        throw new Error(`HTTP ${r.status}`);
      return r.json();
    }).then((r) => {
      if (!t)
        return;
      const { width: e, height: m } = r.meta.master_resolution;
      C({
        vjsAspectRatio: `${e}:${m}`,
        cssAspectRatio: `${e} / ${m}`,
        textTracks: r.meta.video.text_tracks ?? []
      });
    }).catch((r) => {
      console.error("AWS video player: Error fetching meta data", r), t && C({ vjsAspectRatio: "16:9", cssAspectRatio: "16 / 9", textTracks: [] });
    }), () => {
      t = !1;
    };
  }, [f]), R(() => {
    !d || !(s != null && s.textTracks.length) || s.textTracks.forEach((t) => {
      var r;
      (r = a.current) == null || r.addRemoteTextTrack({
        ...t,
        src: `${f}${t.src}`
      });
    });
  }, [d, s, f]), R(() => {
    var m;
    if (!s) return;
    const t = document.createElement("video-js");
    (m = W.current) == null || m.appendChild(t);
    const r = x ? { ...g, fill: !0, fluid: !1 } : { ...g, aspectRatio: s.vjsAspectRatio }, e = a.current = ve(t, r, () => {
    });
    return e.on("ready", () => {
      S(!0);
    }), e.on("loadedmetadata", () => {
      j(!0);
    }), e.on("seeking", () => {
      U.current = !0;
    }), e.on("seeked", () => {
      N.current = !0;
    }), e.on("play", () => {
      k(!0), N.current ? N.current = !1 : i.current({
        type: "playing",
        base: { ...y(e) },
        trackingValue: "play"
      });
    }), e.on("pause", () => {
      U.current ? U.current = !1 : i.current({
        type: "pause",
        base: { ...y(e) },
        trackingValue: "pause"
      });
    }), e.on("ended", () => {
      i.current({
        type: "ended",
        base: { ...y(e) },
        trackingValue: "end"
      });
    }), e.on("timeupdate", () => {
      i.current({
        type: "timeupdate",
        base: { ...y(e) },
        trackingValue: "timeupdate"
      });
    }), e.on("error", (O) => {
      var X, Y, Z;
      const Q = ((Z = (Y = (X = O == null ? void 0 : O.target) == null ? void 0 : X.player) == null ? void 0 : Y.error_) == null ? void 0 : Z.code) || "VIDEOJS_UNKNOWN_ERROR";
      i.current({
        type: "error",
        base: { ...y(e) },
        trackingValue: "videoError",
        errorCode: Q
      }), console.error(Q);
    }), () => {
      e.isDisposed() || e.dispose(), a.current = null, S(!1), j(!1);
    };
  }, [f, s, x, p, o, $]), R(() => {
    !a.current || !p || (a.current.autoplay($), a.current.src([
      {
        src: p,
        type: "application/x-mpegURL"
      }
    ]));
  }, [$, p]);
  const de = async () => {
    if (a.current && d)
      try {
        await a.current.play();
      } catch (t) {
        console.error("VideoJS (AWS) play failed:", t), k(!1);
      }
  }, pe = () => {
    k(!1), a.current && a.current.pause();
  }, ye = b(
    u["aws-player"],
    o && u["aws-player__controls--hidden"],
    n && u["aws-player--fullscreen"],
    M && u["aws-player--fullscreen-videoloop"],
    ce && u["aws-player--cover"],
    le && u["aws-player--contain"]
  ), fe = n ? b(
    c["video-player__content--absolute"],
    d && E && c["video-player__content--absolute-active"]
  ) : b(
    c["video-player__content--relative"],
    !o && c["video-player__content--regular"],
    P && c["video-player__content--relative-fill-parent-height"],
    o && h && c["video-player__content--relative-fullscreen"],
    o && ue && c["video-player__content--relative-ready"]
  ), K = s != null && s.cssAspectRatio ? { "--video-player-aspect-ratio": s.cssAspectRatio } : void 0, q = P ? void 0 : ge(T), me = (q ? { "--video-player-aspect-ratio": q } : void 0) ?? (!P && !M && !n ? K : void 0);
  return /* @__PURE__ */ L("div", { className: c["video-player__service--aws-video-js"], children: [
    n && _ && /* @__PURE__ */ v(
      ee,
      {
        preview: _,
        previewAlt: D,
        isPlaying: E,
        fullscreen: h,
        error: !1
      }
    ),
    /* @__PURE__ */ L("div", { className: fe, style: me, children: [
      !o && !n && _ && /* @__PURE__ */ v(
        ee,
        {
          preview: _,
          previewAlt: D,
          isPlaying: E,
          fullscreen: !1,
          error: !1,
          fillContainer: !0
        }
      ),
      /* @__PURE__ */ v("div", { className: ye, "data-vjs-player": !0, style: n ? K : void 0, children: /* @__PURE__ */ v("div", { ref: W }) })
    ] }),
    /* @__PURE__ */ v(
      he,
      {
        onPlay: de,
        onPause: pe,
        isPlaying: E,
        pauseLabel: re,
        playLabel: se,
        videoTitle: A,
        videoloop: o,
        fullscreen: n
      }
    )
  ] });
};
export {
  $e as VideoJS
};
